'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _SwapRightOutlined = _interopRequireDefault(require('./lib/icons/SwapRightOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _SwapRightOutlined;
exports.default = _default;
module.exports = _default;